module.exports = __webpack_public_path__ + "static/media/id-card.1f5d1096.svg";